// Release Note Item types
export enum ReleaseNoteStatus {
  Pending = 0,
  Generated = 1,
  Edited = 2,
  Published = 3,
  Failed = 4,
  Excluded = 5,
}

export interface ReleaseNoteItem {
  id: string;
  issueKey: string;
  projectKey: string;
  summary: string;
  description?: string;
  issueType?: string;
  acceptanceCriteria?: string;
  module?: string;
  components?: string;
  labels?: string;
  productSuite?: string;
  generatedContent?: string;
  currentContent?: string;
  status: ReleaseNoteStatus;
  jiraUrl?: string;
  createdAt: string;
  updatedAt: string;
  generatedAt?: string;
  lastEditedAt?: string;
  lastEditedBy?: string;
  publishedAt?: string;
  releaseId?: string;
  publishedVersion?: string;
  customer?: string;
  errorMessage?: string;
}

export interface ReleaseNoteItemFilter {
  productSuite?: string;
  status?: ReleaseNoteStatus;
  searchTerm?: string;
  excludePublished?: boolean;
  excludeExcluded?: boolean;
  issueTypes?: string[];
  generatedAfter?: string;
  generatedBefore?: string;
}

export interface PagedResult<T> {
  items: T[];
  totalCount: number;
  page: number;
  pageSize: number;
}

// Release types
export interface Release {
  id: string;
  title: string;
  version?: string;
  description?: string;
  releaseDate: string;
  tags?: string[];
  itemGroups: ReleaseItemGroup[];
  itemIds?: string[];
  isPublished: boolean;
  externalId?: string;
  publishedAt?: string;
  publishedBy?: string;
  postPublishUpdateCount?: number;
  lastPostPublishUpdatedAt?: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
}

export interface ReleaseItemGroup {
  productSuite: string;
  displayOrder: number;
  items: ReleaseItemSummary[];
}

export interface ReleaseItemSummary {
  itemId: string;
  issueKey: string;
  summary: string;
  content: string;
  module?: string;
  displayOrder: number;
}

// Release Type (template)
export interface ReleaseType {
  id: string;
  name: string;
  descriptionTemplate: string;
  requiresVersion: boolean;
  versionUrl?: string;
  isDefault: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

// Module Mapping
export interface ModuleMapping {
  id: string;
  jiraModule: string;
  productSuite: string;
  displayOrder: number;
  isActive: boolean;
  externalCategoryId?: string;
  createdAt: string;
  updatedAt: string;
}

// Query Filter
export interface QueryFilter {
  id: string;
  name: string;
  description?: string;
  projectKeys: string[];
  issueTypes: string[];
  triggerStatus: string;
  additionalJql?: string;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// Term (glossary / acronym definition)
export interface Term {
  id: string;
  term: string;
  definition: string;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

// Jira Field
export interface JiraField {
  id: string;
  name: string;
  customFieldId?: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// Subscriber
export interface Subscriber {
  id: string;
  email: string;
  source: string;
  addedBy?: string;
  createdAt: string;
  isDeleted: boolean;
  deletedAt?: string;
  deletedBy?: string;
}

// API Response types
export interface ApiResponse<T> {
  data?: T;
  error?: string;
  success: boolean;
}

export interface PublishRequest {
  releaseTypeId: string;
  releaseDate: string;
  description: string;
  version?: string;
  versionUrl?: string;
  itemIds: string[];
}

export interface PublishResponse {
  releaseId: string;
  externalId: string;
  message: string;
}

export interface UpdateReleaseRequest {
  title?: string;
  releaseDate: string;
  description?: string;
  version?: string;
  itemIds: string[];
}

export interface UpdateReleaseResponse {
  releaseId: string;
  externalId: string;
  message: string;
  itemsAdded: number;
  itemsRemoved: number;
}
